import { InputMaskTokenDictionary } from '../../../../../hooks/useInputMask/model';

export const SMS_CODE_INPUT_MASK = '####';

export const smsCodeInputMaskTokens: InputMaskTokenDictionary = {
  '#': {
    pattern: /\d/,
  },
};
